export const LANDING = '/';
export const CONTACT_US = '/contact';
export const FAQ = '/faq';
export const RESOURCES = '/resources';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const HOME = '/home';
export const ACCOUNT = '/account';
export const ADMIN = '/admin';
export const PASSWORD_FORGET = '/pw-forget';